import { HttpHeaders } from '@angular/common/http'
import { computed, Injectable, signal } from '@angular/core'

import { TicketInfo } from '@definitions/ticket'

@Injectable({
	providedIn: 'root',
})
export class TicketInfoState {
	readonly ticketInfo = signal<TicketInfo | null>(null)

	readonly operatorCompanyId = computed(() => this.ticketInfo()?.company?.operatorId ?? 0)
	readonly parkingLocationId = computed(() => this.ticketInfo()?.location?.id ?? 0)

	readonly operatorIdHeader = computed(() => {
		const operatorCompanyId = this.operatorCompanyId()

		return new HttpHeaders({
			'Operator-Id': String(operatorCompanyId),
		})
	})
	readonly headers = computed(() => {
		const operatorIdHeader = this.operatorIdHeader()
		const parkingLocationId = this.parkingLocationId()

		return operatorIdHeader.set('Location-Id', String(parkingLocationId))
	})
}
